import * as R from "remeda";
import { BsonDocument, LineBotProviderData, LineNotificationSettingsData } from "@/API";
import { Button, Group, Modal, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, forwardRef, useEffect, useImperativeHandle, useState } from "react";

export const LineNotificationSettingsDataEdit = forwardRef((props: { value: BsonDocument, onChange: (value: BsonDocument) => void }, ref) => {
    const form = useForm<LineNotificationSettingsData>({
        initialValues: props.value,
        onValuesChange: values => props.onChange(values)
    });

    useImperativeHandle(ref, () => ({
        validate: () => form.validate()
    }));

    useEffect(() => {
        if (!R.isDeepEqual(form.values, props.value)) {
            form.setValues(props.value);
        }
    }, [props.value]);

    return <>
        <div>
            <TextInput
                label="Token"
                {...form.getInputProps('token')}
            />
            <TextInput
                label="發送對象"
                {...form.getInputProps('to')}
            />
        </div>
    </>

});